import { createStore } from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'
import taxes from './modules/taxes'
import brands from './modules/brands'
import attributs from './modules/attributs'
import lots from './modules/lots'
import categories from './modules/categories'
import variations from './modules/variations'
import products from './modules/products'
import auth from "@/store/modules/auth";
import contacts from './modules/contacts'
import countries from './modules/settings/countries'
import cities from './modules/settings/cities'
import user from "@/store/modules/user";
import permission from './modules/permission'
import role from "@/store/modules/role";
import company from "@/store/modules/company";
import currencies from "@/store/modules/settings/currencies";
import gender from "@/store/modules/settings/gender";
import stats from "@/store/modules/stats";
import configs from "@/store/modules/settings/configs";
import moduleAccess from "@/store/modules/moduleAccess";
import license from "@/store/modules/license";
import normalization from "@/store/modules/normalization";
import multiSociety from "@/store/modules/multiSociety";
import notifications from "@/store/modules/notifications"
import twilio from './modules/twilio'
import notice from './modules/notice'
import areas from './modules/settings/areas'
import filters from "@/store/modules/filters";
import shop from "@/Modules/Shop/store/index"
import offices from "./modules/offices"
import timeZones from "./modules/timeZones"
import payments from './modules/payments'
import department from './modules/department'
import post from './modules/post'
import box from './modules/box'
import bundle from './modules/bundle'
import reason from './modules/reason'
import session from './modules/session'
import stock from './modules/stock'
import dgiTaxes from "./modules/dgiTaxes";

const initialState = {
  isAppLoaded: false,
  isAppModuleLoaded: false,
  appAsideMinimize: true
}

export default createStore({
  state: initialState,

  getters,
  mutations,
  actions,

  modules: {
    taxes,
    brands,
    attributs,
    categories,
    variations,
    products,
    auth,
    twilio,
    countries,
    cities,
    contacts,
    permission,
    user,
    role,
    company,
    currencies,
    gender,
    stats,
    notice,
    configs,
    moduleAccess,
    license,
    normalization,
    multiSociety,
    notifications,
    areas,
    filters,
    shop,
    offices,
    timeZones,
    payments,
    department,
    post,
    box,
    bundle,
    lots,
    reason,
    session,
    stock,
    dgiTaxes
  },

  plugins: [
      createPersistedState({
        paths: ['user.currentUser', 'user.companyInfo', 'auth', 'company', 'shop.pos.carts', 'shop.pos.activeCartIndex']
    })
  ]
})
